import i18n from '@/i18n';
import moment from 'moment';

function filterAndFormatList(list) {
    return Object.entries(list)
        .filter(([key, value]) => getTranslationForGivenKey(key) !== null && value)
        .map(([key, value]) => [getTranslationForGivenKey(key), formatData(key, value)]);
}

function formatData(key, value) {
    switch (key) {
        case 'eventTime':
            return formatTimestamp(value);
        case 'distanceCovered':
            return (value ? value + ' ' + i18n.t('map.tooltip.distance_unit') : '-');
        case 'batteryLevel':
            return (value ? value + ' %' : '-');
        case 'internalTemperature':
        case 'coolant':
            return (value ? value + ' ℃' : '-');
        case 'engineRPM':
            return (value ? value + ' ' + i18n.t('map.tooltip.rpm_unit') : '-');
        case 'charging':
            if (value == "1") {
                return i18n.t('map.tooltip.charging_state_true');
            } else if (value == "0") {
                return i18n.t('map.tooltip.charging_state_false');
            }
            return '-';
        case 'door':
            if (value == "1") {
                return i18n.t('map.tooltip.door_state_true');
            } else if (value == "0") {
                return i18n.t('map.tooltip.door_state_false');
            }
            return '-';
        case 'bonnet':
            if (value == "1") {
                return i18n.t('map.tooltip.bonnet_state_true');
            } else if (value == "0") {
                return i18n.t('map.tooltip.bonnet_state_false');
            }
            return '-';
        default:
            return value;
    }
}

function getTranslationForGivenKey(paramKey) {
    const transKey = 'map.vehicle_can_data.' + paramKey;
    const trans = i18n.t(transKey);
    if (trans != transKey) {
        return trans;
    }
    return null;
}

function formatTimestamp(timestamp) {
    if (timestamp) {
        return moment(timestamp).format('DD.MM.YYYY HH:mm:ss');
    }
    return timestamp
}

export default {
    filterAndFormatList,
    formatTimestamp
}